<template>
  <div class="row how-to">
    <div class="col col--md-4">
      <FancyIconCircle class="how-to__icon">
        <CommentsIcon />
      </FancyIconCircle>
      <VText class="how-to__title" component="h2" variant="h4"
        >1. Send Invitation</VText
      >
      <VText gutterBottom
        >Send your referral link to friends and tell them how cool Campsite
        is!</VText
      >
    </div>
    <div class="col col--md-4">
      <FancyIconCircle class="how-to__icon">
        <ClipboardIcon />
      </FancyIconCircle>
      <VText class="how-to__title" component="h2" variant="h4"
        >2. Registration</VText
      >
      <VText gutterBottom>They sign up for a Pro account on Campsite.</VText>
    </div>
    <div class="col col--md-4">
      <FancyIconCircle class="how-to__icon">
        <MoneyIcon />
      </FancyIconCircle>
      <VText class="how-to__title" component="h2" variant="h4"
        >3. Earn Credit</VText
      >
      <VText gutterBottom
        >You both get a $10 credit applied to your account.</VText
      >
    </div>
  </div>
</template>

<script>
import {
  VText,
  MoneyIcon,
  ClipboardIcon,
  CommentsIcon,
  FancyIconCircle,
} from '@campsite-bio/component-lib';

export default {
  components: {
    FancyIconCircle,
    VText,
    MoneyIcon,
    ClipboardIcon,
    CommentsIcon,
  },

  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.how-to {
  margin-bottom: 2.5rem;
}

.how-to__icon,
.how-to__title.how-to__title {
  margin-bottom: 0.5rem;
}
</style>
